/**
 * Converts a string to camelCase.
 * Transforms strings with spaces, hyphens, or underscores into camelCase.
 * E.g., "hello-world" → "helloWorld", "Hello World" → "helloWorld"
 *
 * @param str - The string to convert
 * @returns The camelCase version of the input string
 * @throws {TypeError} If input is not a string
 */
export function toCamelCase(str: string): string {
  if (typeof str !== 'string') {
    throw new TypeError('Input must be a string');
  }

  return str.replace(/^([A-Z])|[\s-_]+(\w)/g, (_match, p1, p2) =>
    p2 ? p2.toUpperCase() : p1.toLowerCase()
  );
}
